import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import * as _ from 'lodash';

@Component({
  selector: 'mapfre-auditlib-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {

  @Input() opened: boolean = true;
  public loading: boolean;

  constructor(private loadingService: LoadingService) { }

  ngOnInit() {
    if (_.isUndefined(this.loading)) {
      this.loadingService.observer.subscribe((loading) => {
        this.loading = loading;
      });
    }
  }

  _toggleSidebar() {
    this.opened = !this.opened;
  }

}
